var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMembers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 10V9c0-.53-.196-1.04-.546-1.414A1.806 1.806 0 009.967 7H6.7c-.495 0-.97.21-1.32.586-.35.375-.547.884-.547 1.414v1m3.375-4a2 2 0 10.001-3.999A2 2 0 008.208 6zM3 3.5v1.999L5 5.5v1H3v2H2v-2H0v-1h2v-2h1z",
    fill: "var(--kf-color-gray-700)",
    fillRule: "nonzero"
  })));
}
export default SvgAddMembers;